import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Usuario } from '@app/base/interfaces';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private usuarioLogueadoSubject: BehaviorSubject<Usuario>;
    public usuarioLogueado: Observable<Usuario>;
    public errorLogin = new Subject<any>();

    constructor(private http: HttpClient) {
        this.usuarioLogueadoSubject = new BehaviorSubject<Usuario>(
            JSON.parse(localStorage.getItem('usuario_logueado') || 'null')
        );
        this.usuarioLogueado = this.usuarioLogueadoSubject.asObservable();
    }

    public get usuarioLogueadoData() {
        return this.usuarioLogueadoSubject.value;
    }

    getDatosUsuario() {
        return this.http
            .post<Usuario>(
                environment?.getDataUsuarioUrl || `${environment.apiUrl}/login`,
                {}
            )
            .subscribe({
                next: (dataUsuario) => {
                    const usuario = {
                        ...this.usuarioLogueadoData,
                        ...dataUsuario,
                    };
                    localStorage.setItem(
                        'usuario_logueado',
                        JSON.stringify(usuario)
                    );
                    this.usuarioLogueadoSubject.next(usuario);
                },
                error: (err) => {
                    console.log(err);
                    this.errorLogin.next(err);
                },
            });
    }

    login(usuario: string, password: string) {
        return this.http
            .post<Usuario>(
                environment?.loginUrl || `${environment.apiUrl}/login`,
                {
                    rutTrabajador: usuario,
                    password,
                }
            )
            .subscribe({
                next: (usuario) => {
                    localStorage.setItem(
                        'usuario_logueado',
                        JSON.stringify(usuario)
                    );
                    this.usuarioLogueadoSubject.next(usuario);
                },
                error: (err) => {
                    console.log(err);
                    this.errorLogin.next(err);
                },
                complete: () => {
                    this.getDatosUsuario();
                },
            });
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('usuario_logueado');
        this.usuarioLogueadoSubject.next(null as unknown as Usuario);
    }
}
